import { ClassAttributes, HTMLAttributes } from "react";

export default function CartBody({ children, className, ...props }: ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`bg-white rounded-sm border border-solid border-light-170 ${className}`} {...props} >
      {children}
    </div>
  )
}